module.exports = __webpack_public_path__ + "img/Partnership.dd381e8d.png";